import { FunctionComponent, useState, useEffect } from 'react';
import { Dropdown } from '@fluentui/react';
import { IDynamicEditorComponentProps } from './DynamicEditorComponent';
import { Lookup } from '../../../Entities/ContentConfiguration/Lookup/Lookup';
import { DropdownOptionEx } from '../../../Utilities/DropdownOptionEx';
import { ContentConfigurationService } from '../../../Services/ContentConfigurationService';
 
interface IProps extends IDynamicEditorComponentProps { 
    Item: string;
    Update: (value: string) => void;
    Key?: string;
}

const LookupSelector: FunctionComponent<IProps> = props => {
    const [lookups, setLookups] = useState<Array<Lookup>>();

    useEffect(() => {
		let mounted = true;
        const fetchLookups = async () => {
			const lookups = await ContentConfigurationService.GetLookups();
			if (mounted)
				setLookups(lookups);
        };
		fetchLookups();
		return () => {
			mounted = false
		};
    }, [])

    const onChange = (item: string): void => {
		props.Update(item);
    };

	return  (
		<>
			{ lookups && 
				<Dropdown
					onChange={ (ev, option, idx) => onChange(option.key as string)}
					options={ DropdownOptionEx.toDropdownOptionsAddEmptyEntry(lookups, _ => _.id, _ => _.Name) }
					defaultSelectedKey={ props.Item }
					disabled={props.ReadOnly || !lookups}
				/>
			}
		</>
	)
}

export default LookupSelector;